const csrfStorageKey = 'biggrow_admin_csrf';
const emailStorageKey = 'biggrow_admin_email';

export function setAdminCsrf(token: string | null) {
  if (token) sessionStorage.setItem(csrfStorageKey, token);
  else sessionStorage.removeItem(csrfStorageKey);
}

export function setAdminEmail(email: string | null) {
  if (email) sessionStorage.setItem(emailStorageKey, email);
  else sessionStorage.removeItem(emailStorageKey);
}

export function getAdminEmail(): string {
  return sessionStorage.getItem(emailStorageKey) || '';
}

export function adminHeaders(): Record<string, string> {
  const token = sessionStorage.getItem(csrfStorageKey);
  return token ? { 'X-CSRF-Token': token } : {};
}

export async function adminSession(apiBase: string): Promise<boolean> {
  const response = await fetch(`${apiBase}/auth.php?action=me`, { credentials: 'same-origin' });
  const data = await response.json();
  if (data.authenticated && data.csrf) {
    setAdminCsrf(data.csrf);
    if (data.email) setAdminEmail(data.email);
  }
  return Boolean(data.authenticated);
}

export async function adminFetch(input: RequestInfo | URL, init: RequestInit = {}) {
  return fetch(input, { ...init, credentials: 'same-origin', headers: { ...adminHeaders(), ...(init.headers || {}) } });
}
